import { useSearchParams } from '@remix-run/react'
import { ReactNode, createContext, useContext, useState } from 'react'
import { ResetPasswordModal } from './features/ResetPasswordModal'
import { AuthenticationModal } from './Modal'
import { useSession } from './session'

const useInternal = () => {
  const [searchParams] = useSearchParams()
  const [isOpen, setOpen] = useState(false)
  const [isOpenResetPassword, setOpenResetPassword] = useState(false)

  const session = useSession()

  const openModal = () => {
    setOpenResetPassword(false)

    setOpen(true)
  }

  const openModalResetPassword = () => {
    setOpen(false)

    setOpenResetPassword(true)
  }

  return {
    isOpen,
    setOpen,
    isOpenResetPassword,
    setOpenResetPassword,
    openModal,
    openModalResetPassword,
    session,
  }
}

type AuthenticationContext = ReturnType<typeof useInternal>

const AuthenticationContext = createContext<AuthenticationContext>(undefined)

export const AuthenticationProvider = ({
  children,
}: {
  children: ReactNode
}) => {
  const value = useInternal()

  return (
    <AuthenticationContext.Provider value={value}>
      {children}

      <AuthenticationModal {...value} />
      <ResetPasswordModal {...value} />
    </AuthenticationContext.Provider>
  )
}

export const useAuthenticationContext = (): AuthenticationContext => {
  const context = useContext(AuthenticationContext)

  if (context === undefined) {
    throw new Error(
      'useAuthenticationContext must be used within a AuthenticationProvider',
    )
  }

  return context
}
